import { render } from "./SideImage.vue?vue&type=template&id=0cf1b9d0"
import script from "./SideImage.vue?vue&type=script&lang=js"
export * from "./SideImage.vue?vue&type=script&lang=js"
script.render = render

export default script